import { createSlice } from '@reduxjs/toolkit';

/**
 * Creates a new message object.
 *
 * @param {Object} params - The parameters for the new message.
 * @param {string} [params.content=''] - The content of the message.
 * @param {boolean} [params.isUploading=false] - Indicates if the message is currently being uploaded.
 * @param {boolean} [params.containsFile=false] - Indicates if the message contains a file.
 * @returns {Object} The new message object.
 */
function newMessage(params = {}) {
	return {
		content: params.content ?? '',
		isUploading: params.isUploading ?? false,
		containsFile: params.containsFile ?? false,
	};
}

export const messages = createSlice({
	name: 'messages',
	initialState: {
		chat: {}, // Store chat messages
		newMessage: newMessage(), // Store new temp message to share between components
		update: false, // Trigger to update messages list in chat instance
		sendToAPI: false, // Trigger to send message to API
		readyToUploadFile: false, // Trigger to upload file
	},
	reducers: {
		setUpdate: (state, action) => {
			state.update = action.payload.update;
		},
		setNewMessage: (state, action) => {
			state.newMessage = newMessage(action.payload.newMessage);
		},
		setChat: (state, action) => {
			state.chat = action.payload.chat;
		},
		setSendToAPI: (state, action) => {
			state.sendToAPI = action.payload.sendToAPI;
		},
		setReadyToUploadFile: (state, action) => {
			state.readyToUploadFile = action.payload.readyToUploadFile;
		},
		resetAfterSend: (state) => {
			state.newMessage = newMessage();
			state.sendToAPI = false;
			state.update = false;
		},
		resetMessagesState: (state) => {
			state.chat = {};
			state.tempData = {};
			state.update = false;
			state.sendToAPI = false;
			state.readyToUploadFile = false;
		},
	},
});

export const {
	resetAfterSend,
	resetMessagesState,
	setChat,
	setNewMessage,
	setReadyToUploadFile,
	setSendToAPI,
	setUpdate,
} = messages.actions;

export default messages.reducer;
